import CommonError from '../Common/CommonError'
import { error404 } from '../ErrorSvg'

const Error404Container = () => {
  return (
    <CommonError src={error404} />
  )
}

export default Error404Container